$((function () {
    if ($("form.product_form").submit((function (e) {

        if (!window.addingProduct) {
            window.addingProduct = !0, e.preventDefault();
            var productForm = e.target, productHandle = $(productForm).find("#product-handle").val() || "";
          const variantId = (new URL(window.location.href)).searchParams.get('variant') || document.querySelector("input.product-first")?.value
            $.post($(productForm).attr("action"), $(productForm).serialize()).then((function () {
                $(productForm).attr("action", " "), $(productForm).trigger("submit"), setTimeout((function () {
                    window.location = "/pages/recommendations?product=" + productHandle + '&variant=' + variantId
                }), 0)
            }))
        }
    })), "/pages/recommendations" === window.location.pathname) {
        var productHandle = getUrlParameter("product");
        var variantId = getUrlParameter("variant");
        if (!productHandle || !variantId) return window.location.href = "/cart";

        function getCartSuccess(cart) {
            $(".recommendations-cart-items").text(cart.item_count + (cart.item_count > 1 ? " items" : " item")), $(".recommendations-cart-total").text(Shopify.formatMoney(cart.total_price)), $.get("/products/" + productHandle + ".json").then((function success(res) {
              
              console.log('res.product', res.product)
              const variantImage = res.product.images.find(img => res.product.variants.find(v => v.id === parseInt(variantId))?.image_id === img.id)?.src;
              const productImage = res.product.image?.src
                $(".recommendations-product-image").css("background-image", "url(" + (variantImage ?? productImage) + ")"), $(".recommendations-product-title").text(res.product.title), renderSpecialOrderMessage(res.product, cart.items), fadeInPage(), "function" == typeof trigger_messages && trigger_messages()
            }), (function error(err) {
                console.error("An error occurred fetching product data", err)
            }))
        }

        $.get("/cart.json").done(getCartSuccess).fail((function getCartError(err) {
            "OK" === err.statusText ? getCartSuccess(JSON.parse(err.responseText)) : err.total_price ? getCartSuccess(err) : console.error("An error occurred fetching cart data", err)
        }))
    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex, results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(location.search);
        return null === results ? "" : decodeURIComponent(results[1].replace(/\+/g, " "))
    }

    function fadeInPage() {
        $(".recommendations-section").animate({opacity: 1}, 600)
    }

    function renderSpecialOrderMessage(product, cartItems) {
        var isSpecialOrderEnable = "true" == $("#recommendations_enable_special_orders").text();
        if (console.log("recommendations_enable_special_orders", isSpecialOrderEnable), isSpecialOrderEnable) {
            var productInCart = _.find(cartItems, (function (cartItem) {
                return cartItem.product_id == product.id
            }));
            if (productInCart) {
                var variantSelected = _.find(product.variants, (function (variant) {
                    return variant.id == productInCart.variant_id
                }));
                variantSelected && variantSelected.inventory_quantity < productInCart.quantity && "continue" == variantSelected.inventory_policy && $("#recommendations-special_order_message").css("display", "block")
            }
        }
    }
}));
